import { render, staticRenderFns } from "./RegistrationCard.vue?vue&type=template&id=c3900e74&scoped=true"
import script from "./RegistrationCard.vue?vue&type=script&lang=ts"
export * from "./RegistrationCard.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationCard.vue?vue&type=style&index=0&id=c3900e74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3900e74",
  null
  
)

export default component.exports